import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_2 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_3 = { class: "title" }

import { computed, onMounted, ref } from "vue";
import { debounce } from "lodash-es";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { formGet, formPut } from "@/common/api/rest/form/form";

import type { FormPayloadType } from "@/common/types/form";

import { RegisterTheme } from "@/common/themes";
import { formsForm } from "@/components";
import FormQuestion from "@/components/tabs/form-question.vue";
import { iconMenu, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const formPayload = ref<FormPayloadType | null>(null);
const selectedMenu = ref<string>("home");

const isLoading = ref(false);

const accountId = computed(() => String(route.params.id));
const formId = computed(() => String(route.params.form));

const menuTabs = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.home"),
  },
  {
    key: "question",
    icon: "field",
    label: t("common.labels.questions"),
  },
]);

function back() {
  router.push(`/${accountId.value}/register/form`);
}

function fetchForm() {
  isLoading.value = true;

  formGet(accountId.value, formId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        formPayload.value = {
          name: data.name,
          code: data.code,
          description: data.description,
          metadata:
            typeof data.metadata === "string"
              ? JSON.parse(data.metadata)
              : typeof data.metadata === "object"
                ? data.metadata
                : null,
        };
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch((error) => {
      console.log("error", error);
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      isLoading.value = false;
    });
}

function updateForm(data: FormPayloadType) {
  const payload = {
    ...data,
    metadata:
      typeof data.metadata === "object"
        ? JSON.stringify(data.metadata)
        : data.metadata,
  };

  formPut(accountId.value, formId.value, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchForm();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeMenu(key: string) {
  selectedMenu.value = key;
  fetchForm();
}

function updateOrder(data: string[]) {
  if (!formPayload.value) return;

  const metadata = {
    ...formPayload.value.metadata,
    orders: data,
  };

  formPayload.value.metadata = JSON.stringify(metadata);
  updateForm(formPayload.value);
}

const debounceForm = debounce(updateForm, 1000);

onMounted(() => {
  if (formId.value) {
    fetchForm();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RegisterTheme), { "tab-active": "form" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(svgIcon), {
            icon: "document",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit", { concat: _unref(t)("common.labels.form") })), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-back btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "close",
            size: "1.25rem"
          })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(iconMenu), {
        tabs: menuTabs.value,
        active: selectedMenu.value,
        onSelected: changeMenu
      }, {
        content: _withCtx(() => [
          (selectedMenu.value === 'home')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("common.labels.form")), 1),
                _createVNode(_unref(formsForm), {
                  width: "100%",
                  data: formPayload.value,
                  onUpdateData: _unref(debounceForm)
                }, null, 8, ["data", "onUpdateData"])
              ], 64))
            : _createCommentVNode("", true),
          (selectedMenu.value === 'question')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (accountId.value && formId.value)
                  ? (_openBlock(), _createBlock(FormQuestion, {
                      key: 0,
                      "account-id": accountId.value,
                      "form-id": formId.value,
                      ordering: true,
                      orders: formPayload.value?.metadata?.orders,
                      "onUpdate:order": _cache[1] || (_cache[1] = ($event: any) => (updateOrder($event)))
                    }, null, 8, ["account-id", "form-id", "orders"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["tabs", "active"])
    ]),
    _: 1
  }))
}
}

})